import "./user-avatar.css";

type UserAvatarProps = {
	name: string;
	size?: "xs" | "small" | "medium" | "large";
};

const getInitials = (fullName: string): string => {
	const parts = fullName.trim().split(/\s+/);

	if (parts.length === 0) {
		return "";
	}

	const firstInitial = parts[0]?.charAt(0).toUpperCase() ?? "";

	// If there's a last name, include it
	if (parts.length > 1) {
		const lastInitial = parts.at(-1)?.charAt(0).toUpperCase() ?? "";
		return `${firstInitial}${lastInitial}`;
	}

	return firstInitial;
};

export function UserAvatar({
	name,
	size = "medium",
}: Readonly<UserAvatarProps>) {
	const initials = getInitials(name);
	const sizeClass = `user-avatar-${size}`;

	return <div className={`user-avatar ${sizeClass}`}>{initials}</div>;
}
